export default "__VITE_ASSET__BXhhmJV0__"